import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { AnimatedSection } from '../components/AnimatedSection';
import { CTASection } from '../components/CTASection';
import { cases } from '../data/mockData';
export function CaseDetail() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const caseItem = cases.find(c => c.slug === slug);
  if (!caseItem) {
    return <main className="w-full bg-off-white min-h-screen flex items-center justify-center" data-id="element-401">
        <div className="text-center" data-id="element-402">
          <h1 className="text-3xl font-light text-charcoal mb-4" data-id="element-403">
            Case niet gevonden
          </h1>
          <Link to="/cases" className="text-accent hover:underline" data-id="element-404">
            Terug naar cases
          </Link>
        </div>
      </main>;
  }
  const sections = [{
    label: 'Situatie',
    content: caseItem.situatie
  }, {
    label: 'Aanpak',
    content: caseItem.aanpak
  }, {
    label: 'Resultaat',
    content: caseItem.resultaat
  }, {
    label: 'Conclusie',
    content: caseItem.conclusie
  }];
  return <main className="w-full bg-off-white" data-id="element-405">
      {/* Hero */}
      <section className="pt-40 pb-16 bg-charcoal relative overflow-hidden" data-id="element-406">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 relative z-10" data-id="element-407">
          <AnimatedSection data-id="element-408">
            <Link to="/cases" className="inline-flex items-center text-warm-gray/70 hover:text-white text-sm mb-8 transition-colors" data-id="element-409">
              <ArrowLeftIcon size={16} className="mr-2" data-id="element-410" />
              Terug naar cases
            </Link>
            <p className="text-accent text-sm font-medium uppercase tracking-widest mb-4" data-id="element-411">
              Case study
            </p>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-light text-white tracking-tight max-w-3xl" data-id="element-412">
              {caseItem.title}
            </h1>
          </AnimatedSection>
        </div>
      </section>

      {/* Case Image */}
      <section className="relative -mt-1" data-id="element-413">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12" data-id="element-414">
          <AnimatedSection data-id="element-415">
            <div className="rounded-2xl overflow-hidden shadow-lg max-w-4xl mx-auto -mt-8" data-id="element-416">
              <img src={caseItem.image} alt={caseItem.title} className="w-full h-72 md:h-96 object-cover" data-id="element-417" />
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-20" data-id="element-418">
        <div className="max-w-3xl mx-auto px-6 lg:px-12" data-id="element-419">
          {sections.map((section, index) => <AnimatedSection key={section.label} delay={index * 0.1} className="mb-16 last:mb-0" data-id="element-420">
              <div className="flex items-start gap-6" data-id="element-421">
                <div className="shrink-0 w-10 h-10 rounded-full bg-charcoal text-white flex items-center justify-center text-sm font-medium mt-1" data-id="element-422">
                  {index + 1}
                </div>
                <div data-id="element-423">
                  <h2 className="text-2xl font-medium text-charcoal mb-4" data-id="element-424">
                    {section.label}
                  </h2>
                  <p className="text-charcoal/70 leading-relaxed text-base" data-id="element-425">
                    {section.content}
                  </p>
                </div>
              </div>
            </AnimatedSection>)}
        </div>
      </section>

      {/* Internal Links */}
      <section className="pb-12" data-id="element-426">
        <div className="max-w-3xl mx-auto px-6 lg:px-12" data-id="element-427">
          <AnimatedSection data-id="element-428">
            <div className="bg-white rounded-2xl p-8 border border-warm-gray/50" data-id="element-429">
              <h3 className="text-lg font-medium text-charcoal mb-4" data-id="element-430">
                Meer ontdekken
              </h3>
              <div className="flex flex-wrap gap-3" data-id="element-431">
                <Link to="/bedrijfswaardering" className="px-5 py-2.5 bg-off-white rounded-full text-sm text-charcoal hover:bg-accent hover:text-white transition-colors" data-id="element-432">
                  Bedrijfswaardering
                </Link>
                <Link to="/werkwijze" className="px-5 py-2.5 bg-off-white rounded-full text-sm text-charcoal hover:bg-accent hover:text-white transition-colors" data-id="element-433">
                  Onze werkwijze
                </Link>
                <Link to="/adviseurs" className="px-5 py-2.5 bg-off-white rounded-full text-sm text-charcoal hover:bg-accent hover:text-white transition-colors" data-id="element-434">
                  Vind een adviseur
                </Link>
                <Link to="/kennisbank/verkoop/bedrijf-waarderen-voor-verkoop" className="px-5 py-2.5 bg-off-white rounded-full text-sm text-charcoal hover:bg-accent hover:text-white transition-colors" data-id="element-435">
                  Bedrijf waarderen voor verkoop
                </Link>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </section>

      <CTASection title="Ook een objectieve waardering nodig?" subtitle="Ontdek wat uw bedrijf écht waard is met een professionele, onafhankelijke bedrijfswaardering." data-id="element-436" />
    </main>;
}